import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Course } from '../models/model';



@Pipe({ standalone: false, name: 'timeTransform' })
export class TimeTransform implements PipeTransform {
  transform(time: number): string {
    var horas = Math.floor(time / 3600);
    var minutos = Math.floor((time - (horas * 3600)) / 60);
    var segundos = Math.round(time - (horas * 3600) - (minutos * 60));
    return (horas < 10 ? '0' : '') + horas + ':' + (minutos < 10 ? '0' : '') + minutos + ':' + (segundos < 10 ? '0' : '') + segundos;
  }
}

@Pipe({ name: 'durationTransform',standalone: false })
export class DurationTransform implements PipeTransform {
  transform(time: string): number {
    var horas = parseInt(time.split(":")[0]);
    var minutos = parseInt(time.split(":")[1]);
    var segundos = parseInt(time.split(":")[2]);
    return horas * 3600 + minutos * 60 + segundos;
  }
}

@Pipe({ name: 'courseImageUrl', standalone: false })
export class CourseImageUrlPipe implements PipeTransform {
  private readonly BASE = 'https://d3puay5pkxu9s4.cloudfront.net';

  transform(image_url: string, id: string | number): string {
    if (image_url?.includes('curso')) {
      return `${this.BASE}/curso/${id}/card_imagen.jpg`;
    }
    return `${this.BASE}/courses/${id}/img/web/card_imagen.jpg`;
  }
}

@Pipe({
  name: "transformCoursePipe",standalone: false
})
export class TransformCoursePipe implements PipeTransform {
  transform(data: any, origin?: string): Course[] {
    
    function getCoursesFromArray(data: any): Course[] {
      const courses: Course[] = [];
      data.map((item: any) => {
        courses.push(item.Course);
      });
      return courses;
    }
    const courses: Course[] = [];
    let newData = data[0]?.Course ? getCoursesFromArray(data) : data;
          

    newData?.forEach((item: any) => {
      
      const course: Course = {
        id: item.fields?.id ? item.fields.id[0] : item.id,
        duration: item?.fields?.time
          ? parseInt(item.fields.time[0])
          : item?.time
          ? parseInt(item.time)
          : item?.time
          ? parseInt(item.time)
          : item?.time
          ? parseInt(item.time)
          : item?.fields?.duration[0]
          ? parseInt(item.fields.duration[0])
          : item?.duration
          ? parseInt(item.duration)
          : 0,
        name: item.fields?.name[0]
          ? item.fields.name[0]
          : item.nombre
          ? item.nombre
          : item.name
          ? item.name
          : "undefined",
        slug: item.fields?.slug[0] ? item.fields.slug[0] : item.slug,
        media: item.media,
        departmentId: item.fields?.department_id
          ? item?.fields.department_id[0]
          : item?.department_id,
        privacy: item.privacy,
        certificate_es: item.title ? item.title : item.fields?.title ? item.fields.title[0] : undefined,
        certificate_en: item.name_certification ? item.name_certification : item.fields?.certification_name ? item.fields.certification_name[0] : undefined,
        price: item.price ? item.price : item.fields?.price ? parseInt(item.fields.price[0]) : item.precio,
        students: item.students ? item.students : item.fields?.students[0] ? item.fields.students[0] : 0,
        score: item.score ? parseFloat(item.score) : item.fields?.score1[0] ? parseFloat(item.fields.score1[0]) : 0,
        originPetition: origin,
        item_type: item?._item_type,
        highlights: item?._highlights
      };
      courses.push(course);
    });
    return courses;
  }
}

